import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import './styles.css';

import MultipleBarChart from '../../../components/MultipleBarChart';

const messages = defineMessages({
  title: {
    id: 'hubs.admissions.hs-application-stats.title',
    defaultMessage: `Your high school's application history`,
  },
});

class HighSchoolApplicationStats extends React.PureComponent {
  static propTypes = {
    applicationsByYear: PropTypes.object,
  };

  getNumber = (value) =>
    (value || value === 0) && !Number.isNaN(Number(value)) ? Number(value) : 0;

  getChartData = () => {
    const { applicationsByYear } = this.props;
    const chartData = [];

    Object.keys(applicationsByYear)
      .sort((a, b) => Number(b) - Number(a))
      .forEach((key) => {
        if (applicationsByYear[key].totalApplied) {
          const applied = `${applicationsByYear[key].totalApplied} Applied`;
          const accepted = `${applicationsByYear[key].totalAccepted} Accepted`;
          const enrolled = `${applicationsByYear[key].totalEnrolled} Enrolled`;
          chartData.push({
            bars: [
              {
                value: this.getNumber(applicationsByYear[key].totalApplied),
                label: applied,
                color: 'rgba(85,78,219,0.36)',
                dashedPattern: true,
              },
              {
                value: this.getNumber(applicationsByYear[key].totalAccepted),
                label: applicationsByYear[key].totalAccepted ? accepted : '',
                color: '#8B85E6',
              },
              {
                value: this.getNumber(applicationsByYear[key].totalEnrolled),
                label: applicationsByYear[key].totalEnrolled ? enrolled : '',
                color: '#554EDB',
              },
            ],
            label: key,
          });
        }
      });

    return chartData;
  };

  render() {
    const { applicationsByYear } = this.props;

    return !isEmpty(applicationsByYear) ? (
      <div
        className="highschool-application-stats-container common-core-width"
        data-cy="highschool-application-stats-container"
      >
        <h2 className="heading">
          <FormattedMessage {...messages.title} />
        </h2>
        <MultipleBarChart chartData={this.getChartData()} />
      </div>
    ) : null;
  }
}

export default injectIntl(HighSchoolApplicationStats);
